//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import Icon from '@components/atoms/icon/Icon';
import {
  SectionText,
  SubsectionText,
  SubtitleText,
  TitleText,
} from '@components/atoms/text/Text';
import { VibeButtonAnchor } from '@welcome-page/components/onboarding/vibe/VibeButtonAnchor';
import { VibeDemoVideo } from '@welcome-page/components/onboarding/vibe/VibeDemoVideo';
import { ONBOARDING_TRACKING_ID } from '@welcome-page/constants/OnboardingConstants';

// TODO: PD-257587 - remove this component
export const VibeIntroduction = () => {
  return (
    <IntroContainer>
      <ContentPanel>
        <HeaderContainer>
          <LogoContainer>
            <BazaarvoiceLogo />
          </LogoContainer>
          <TitleContainer>
            <WhiteSectionText>Introducing</WhiteSectionText>
            <StyledTitleText>Bazaarvoice Vibe</StyledTitleText>
          </TitleContainer>
        </HeaderContainer>
        <SectionContainer>
          <WhiteSubtitleText>
            Your integrated social content solution
          </WhiteSubtitleText>
        </SectionContainer>
        <SectionContainer>
          <WhiteSubsectionText>
            Unite the power of creators, campaigns, and commerce to deliver a
            full-
            <br />
            funnel content strategy that connects and converts everywhere—from
            <br />
            reach to revenue.
            <br />
            <br /> Ready to learn more? Discover what’s new in our on-demand
            webinar.
          </WhiteSubsectionText>
        </SectionContainer>
        <SectionContainer>
          <VibeButtonAnchor
            trackingId={ONBOARDING_TRACKING_ID.VIBE_WATCH_NOW_BUTTON}
            href='https://bazaarvoice.registration.goldcast.io/webinar/3406c121-ae47-4d0f-bc2f-cbdd6e3432c6'
            target='_'
          >
            Watch Now
          </VibeButtonAnchor>
        </SectionContainer>
      </ContentPanel>
      <ContentPanel>
        <VibeDemoVideo />
      </ContentPanel>
    </IntroContainer>
  );
};

const IntroContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 50px;
`;

const ContentPanel = styled.div(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${theme.spacings[5]};
`,
);

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const StyledTitleText = styled(TitleText)(
  ({ theme }) => `
  color: ${theme.colors.white};
  font-weight: ${theme.fontWeights.bold};
`,
);

const WhiteSectionText = styled(SectionText)(
  ({ theme }) => `
  color: ${theme.colors.white};
`,
);

const WhiteSubsectionText = styled(SubsectionText)(
  ({ theme }) => `
  color: ${theme.colors.white};
  font-weight: ${theme.fontWeights.normal};
  white-space: nowrap;
`,
);

const WhiteSubtitleText = styled(SubtitleText)(
  ({ theme }) => `
  color: ${theme.colors.white};
`,
);

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const SectionContainer = styled.div`
  display: flex;
`;

const BazaarvoiceLogo = styled(Icon).attrs({ name: 'bv-logomark' })(
  ({ theme }) => `
  width: 50px;
  height: 50px;
  color: ${theme.colors.white};
`,
);

const LogoContainer = styled.div(
  ({ theme }) => `
  display: flex;
  align-items: center;
  padding: ${theme.spacings[3]}
`,
);
